export { isElectron } from './is-electron'
export { platformSelect } from './platform'
export { escapeRegExp } from './escape-reg-exp'
